module.exports = __webpack_public_path__ + "static/media/copyIconNew.6aafb4fc.svg";